import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import AbsenceList from '@/components/Absence/AbsenceList.vue';
let VacationPlanner = class VacationPlanner extends Vue {
    isMobile() {
        if (window.screen.availWidth < 481) {
            return true;
        }
        else if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return true;
        }
        else {
            return false;
        }
    }
};
VacationPlanner = __decorate([
    Component({
        data() {
            return {
                userData: {
                    userLoaded: false,
                },
                dateInfo: {
                    year: 0,
                    month: null,
                    week: 0,
                    weekHours: 0,
                    monthHours: 0,
                },
                reports: [],
                tariffScheduleList: [],
            };
        },
        computed: {
            getUserData() {
                return this.$store.getters.getTokenProfile;
            },
            getUser() {
                return (this.$store.getters.getTokenProfile).firstName;
            },
        },
        components: {
            AbsenceList,
            //VacationCalendar,
        },
    })
], VacationPlanner);
export default VacationPlanner;
